import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import makeStyles from '@material-ui/styles/makeStyles';
import * as React from 'react';

const useStyles = makeStyles({
  iconStyle: {
    fill: 'none',
    '&>path': {
      stroke: 'currentColor',
    },
  },
});
function StockIcon(props: SvgIconProps) {
  const classes = useStyles();
  return (
    <SvgIcon className={classes.iconStyle} {...props}>
      <path
        d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
        stroke="#000"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

const MemoStockIcon = React.memo(StockIcon);
export default MemoStockIcon;
